import { Fragment } from 'react';
import type { ITransaction } from '@recargas-dominicanas/core/types';
import { expired, formatCurrency, formatDate, formatTopupNumber, formatRef } from '@recargas-dominicanas/core/utils';
import { DetailModal } from '../detail-modal/detail-modal.component';
import { DetailModalItem } from '../detail-modal-item/detail-modal-item.component';
import { style } from './topup-modal.module.css';

import { 
  ModalContent,
  OutlineButton,
  ModalOptions
} from '@recargas-dominicanas/core/components';

interface Props {
  open: boolean;
  title: string;
  transaction?: ITransaction;
  overlayEnterAnimation?: boolean;
  onPrint?: ()=> void;
  onCancel?: () => void;
  onClose: () => void;
}

export function TopupModal(props: Props) {

  const {
    open,
    title,
    transaction,
    overlayEnterAnimation,
    onPrint,
    onCancel,
    onClose
  } = props;

  if (!transaction) return null;

  const topupNumber = formatTopupNumber(transaction.product, transaction?.phone);

  return (
    <DetailModal
      open={open}
      title={title}
      overlayEnterAnimation={overlayEnterAnimation}
      onClose={onClose}>
      <ModalContent className={style.modalContent}>
        {transaction &&
          <Fragment>
            <DetailModalItem title='Compañía' text={transaction.product.name}/>
            {transaction.ownerName && <DetailModalItem title='Titular' text={transaction.ownerName}/>}
            <DetailModalItem title={topupNumber.title} text={topupNumber.value}/>
            <DetailModalItem title='Monto' text={formatCurrency(transaction.amount)} color='green'/>
            <DetailModalItem title='Beneficio' text={formatCurrency(transaction.profit)} color='green'/>
            {transaction.energyTopup?.kwh && <DetailModalItem title='Monto recargado' text={transaction.energyTopup.kwh}/>}
            {transaction.energyTopup?.totalKwh && 
              <DetailModalItem 
                title='Total recargado' 
                text={`${transaction.energyTopup.totalKwh} kWh`}/>
            }
            <DetailModalItem title='Fecha' text={formatDate(transaction.date)}/>
            <DetailModalItem title='Referencia' text={formatRef(transaction.reference!)}/>
            {transaction.cancelled && <DetailModalItem title='Estado' text='Cancelada'/>}
          </Fragment>
        }
      </ModalContent>
      <ModalOptions>
        {onPrint &&
          <OutlineButton 
            icon='receipt' 
            text='Imprimir' 
            onClick={onPrint}/>
        }
        {transaction && onCancel && !transaction.cancelled && !expired(transaction) &&
          <OutlineButton 
            icon='cancel' 
            text='Cancelar'
            onClick={onCancel}/>
        }
      </ModalOptions>
    </DetailModal>
  );
}
